import dayjs from 'dayjs';
import * as React from 'react';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import { useRecoilValue } from 'recoil';
import ProgressiveList from '../ProgressiveList/ProgressiveList';
import SectionSummary from '../TableRow/SectionSummary';
import TableRow from '../TableRow/TableRow';
import { ICheckedRecord, ITripsOverviewTableData } from '../interfaces';
import { MIN_OFFSET_LENGTH } from '../constants';
import {
  loadingDataAtom,
  offsetAtom,
  rideItemIdsAtom,
  summaryItemIndexesAtom,
} from '../TripsOverviewState';
import { LoadingText } from './LoadingText';

interface ITableBodyProps {
  tableData: ITripsOverviewTableData;
  // columns: ITripsOverviewColumn[];
  selectOneRow: (id: string, customerId: string, isRowChecked: boolean, timestamp: string) => void;
  selectedRecords: ICheckedRecord[];
  selectSectionCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void;
  updateTable: () => void;
  // itemsTable: Item[];
  // innerRefTable: React.LegacyRef<HTMLBodyElement>;
  allCheckedRowsOpened: boolean | null;
  allCheckedRowsClosed: boolean | null;
}

function TableBody(props: ITableBodyProps): JSX.Element {
  dayjs.extend(weekOfYear);
  const offset = useRecoilValue<number>(offsetAtom);
  const rideItemIds = useRecoilValue<string[]>(rideItemIdsAtom);
  const summaryItemIndexes = useRecoilValue<number[]>(summaryItemIndexesAtom);
  const [initialAmountList, setInitialAmountList] = React.useState<number>(0);

  const loadingNewData = useRecoilValue(loadingDataAtom);

  React.useEffect(() => {
    if (rideItemIds.length <= MIN_OFFSET_LENGTH && rideItemIds.length > 0) {
      setInitialAmountList(rideItemIds.length);
    }
  }, [rideItemIds]);

  const handleRenderSectionSummaryByType = (index: number): boolean => {
    if (summaryItemIndexes.includes(index)) {
      return true;
    }
    return false;
  };

  const renderRow = (index: number) => {
    if (rideItemIds[index]) {
      return (
        <React.Fragment key={`TableSectionWithRow-${rideItemIds[index]}-${index}`}>
          <div className="b-table-prehlad-jazd-row">
            {handleRenderSectionSummaryByType(index) && (
              <SectionSummary
                // id={props.tableData.records[index].timestamp.start}
                rideId={rideItemIds[index]}
                key={`section-${rideItemIds[index]}${index}`}
                // columns={props.columns}
                selectedCheckbox={props.selectedRecords}
                selectSectionCheckbox={props.selectSectionCheckbox}
                sectionSummaryData={props.tableData.summaries}
                index={index}
              />
            )}

            <TableRow
              id={rideItemIds[index]}
              // columns={props.columns}
              selectOneRow={props.selectOneRow}
              selectedCheckbox={props.selectedRecords}
              updateTable={props.updateTable}
              // openModalForm={props.openModalForm}
              lastElement={rideItemIds.length === index + 1}
              allCheckedRowsOpened={props.allCheckedRowsOpened}
              allCheckedRowsClosed={props.allCheckedRowsClosed}
              index={index}
            />
          </div>
        </React.Fragment>
      );
    }

    return null;
  };

  return (
    <>
      {initialAmountList > 0 && (
        <ProgressiveList
          initialAmount={initialAmountList}
          idleAmount={MIN_OFFSET_LENGTH}
          progressiveAmount={offset}
          renderItem={renderRow}
          rowCount={rideItemIds.length}
          useWindowScroll
          scrollParent="page-content-wrapper-div"
        />
      )}
      {loadingNewData && <LoadingText />}
    </>
  );
}

export default React.memo(TableBody);
